import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';
declare let firebase: any;

@Component({
  selector: 'empty-page',
  templateUrl: './empty-page.html',
  styleUrls: ['empty-page.scss']
})
export class EmptyPageComponent {
  @Input() title = 'No Selected Record';
  @Input() message = 'Please Select a Record to View or Create a New Record';

  constructor(public db: PouchService, public navCtrl: NavController) {

  }
}
